<template>
  <b-card
    border-variant="secondary"
    header-bg-variant="light"
    header-class="p-3 font-weight-bold"
    header="Where money and evidence will go"
    class="mb-0"
  >
    <b-alert v-if="!plan" variant="light" show class="mb-0">
      Write plans appear after prepare/post status is available. Nothing here moves money.
    </b-alert>
    <div v-else class="row">
      <div
        v-for="dest in destinations"
        :key="dest.key"
        class="col-md-4 mb-3 mb-md-0"
      >
        <div class="font-weight-bolder text-dark mb-1">{{ dest.destinationName }}</div>
        <div class="small text-muted mb-2">{{ dest.whyNeeded }}</div>
        <ul class="small pl-3 mb-2">
          <li v-for="(field, idx) in dest.businessFields" :key="idx">{{ field }}</li>
        </ul>
        <div class="small">
          <strong>From:</strong> {{ dest.oldValue }}
        </div>
        <div class="small">
          <strong>To:</strong> {{ dest.proposedValue }}
        </div>
        <div class="small text-muted mt-1">
          Authority: {{ dest.authoritySource }}
        </div>
        <b-badge :variant="stateVariant(dest.state)" class="mt-2">
          {{ dest.state || "waiting" }}
        </b-badge>
      </div>
    </div>
  </b-card>
</template>

<script>
export default {
  name: "WritePlanPanel",

  props: {
    writePlan: {
      type: Object,
      default: null
    }
  },

  computed: {
    plan: function () {
      return this.writePlan || null;
    },
    destinations: function () {
      if (!this.plan) {
        return [];
      }
      return ["insight", "neon", "zoho"]
        .filter((key) => this.plan[key])
        .map((key) => Object.assign({ key: key }, this.plan[key]));
    }
  },

  methods: {
    stateVariant: function (state) {
      const s = String(state || "").toLowerCase();
      if (s === "done" || s === "complete" || s === "recorded") {
        return "success";
      }
      if (s === "held" || s === "hold") {
        return "warning";
      }
      if (s === "failed") {
        return "danger";
      }
      return "secondary";
    }
  }
};
</script>
